import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { RTEAlertService } from 'rte-library';
import { Report } from '../reports/components/report/models/report.model';
import { UserPermissionReport } from '../models/userPermissionReport';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionReportService {

  headers = new HttpHeaders({
    'No-loading': 'True'
  });

  saveSuccess$: Subject<boolean> = new Subject<boolean>();
  saveError$: Subject<void> = new Subject<void>();

  deleteSuccess$: Subject<boolean> = new Subject<boolean>();
  deleteError$: Subject<void> = new Subject<void>();

  constructor(
    private http: HttpClient,
    private alert: RTEAlertService
  ) { }

  getUserPermissionByReport(report: Report): Observable<UserPermissionReport[]> {
    return this.http.get<UserPermissionReport[]>(environment.apiUrl + 'api/userpermission?idReport=' + report.Id, { headers: this.headers });
  }

  save(user: UserPermissionReport) {
    return this.http.post<boolean>(environment.apiUrl + 'api/userpermission/save', user)
      .subscribe(success => {
        this.saveSuccess$.next(success);
      },
      error => {
        this.saveError$.next();
      });
  }

  delete(user: UserPermissionReport) {
    const params = new HttpParams()
                    .set('id', user.Id.toString())
                    .set('userId', user.UserId.toString())
                    .set('objectId', user.ObjectId.toString());

    return this.http.delete<boolean>(environment.apiUrl + 'api/userpermission/delete', {params})
      .subscribe(success => {
        this.deleteSuccess$.next(success);
      },
      error => {
        this.deleteError$.next();
      });
  }

  deleteByReport(idReport: number) {
    const params = new HttpParams()
                    .set('idReport', idReport.toString());

    return this.http.delete<boolean>(environment.apiUrl + 'api/userpermission/deletebyreportid', {headers: this.headers, params});
  }
}
